import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import AppleWithStem from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/AppleWithStem';
import GraduationHatWithTassle from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/GraduationHatWithTassle';
import PaperShoppingBagEmpty from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PaperShoppingBagEmpty';
import ShieldWithClock360ArrowDarkTheme from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithClock360Arrow';
// styles
import { ColStyledProductCard } from './styles';

export default () => {
  return (
    <SectionContainer
      id='college-savings-plans-help-you-plan'
      backgroundVariant='lightB'
      themeType='lightTheme'>
      <Row align='center'>
        <Col>
          <Typography
            component='h2'
            align='center'
            nextElement='graphic'>
            Types of college <WidowBlock>savings plans</WidowBlock>
          </Typography>
        </Col>
      </Row>
      <Row align='center'>
        <ColStyledProductCard
          medium={6}
          large={5}>
          <ProductCard
            icon={GraduationHatWithTassle}
            backgroundVariant='lightA'
            cardId='product-callout-529-college-savings-plans-link-card'
            cardHeading='529 plans'
            cardText={
              <>
                Parents, grandparents, other family members, even friends can contribute money for college (elementary or high school, too). Any earnings will grow federal income tax&#45;deferred, and many states offer tax deductions.
              </>
            }
            linkId='product-callout-529-college-savings-plans-link'
            linkText='Find out more'
            linkUrl='/529-college-savings-plans/'
          />
        </ColStyledProductCard>
        <ColStyledProductCard
          medium={6}
          large={5}>
          <ProductCard
            icon={AppleWithStem}
            backgroundVariant='lightA'
            cardId='product-callout-coverdale-college-savings-plans-link-card'
            cardHeading='Coverdell Educational Savings Accounts (ESA)'
            cardText={
              <>
                Help cover the costs of college, even kindergarten through 12th grade. Like 529 plans, Coverdell accounts grow tax&#45;deferred, however, there&#39;s a &#36;2,000 yearly contribution limit and those with higher incomes might not be eligible.
              </>
            }
            linkId='product-callout-coverdale-college-savings-plans-link'
            linkText='Find out more'
            linkUrl='/life-and-money/savings-plans-for-college-6-options-to-consider/'
          />
        </ColStyledProductCard>
        <ColStyledProductCard
          medium={6}
          large={5}>
          <ProductCard
            icon={PaperShoppingBagEmpty}
            backgroundVariant='lightA'
            cardId='product-callout-transfers-college-savings-plans-link-card'
            cardHeading={<>Uniform gifts &#38; <WidowBlock>transfers account</WidowBlock></>}
            cardText={
              <>
                Known as UGMA&#47;UTMAs, these custodial accounts let parents (and others) gift money to children. Earnings are taxed at the child&#39;s tax rate, and unlike a 529 or Coverdell account, you can use the money for college or anything else.
              </>
            }
            linkId='product-callout-transfers-college-savings-plans-link'
            linkText='Find out more'
            linkUrl='/life-and-money/custodial-accounts/'
          />
        </ColStyledProductCard>
        <ColStyledProductCard
          medium={6}
          large={5}>
          <ProductCard
            icon={ShieldWithClock360ArrowDarkTheme}
            backgroundVariant='lightA'
            cardId='product-callout-whole-life-insurance-college-savings-plans-link-card'
            cardHeading='Whole life insurance'
            cardText={
              <>
                It&#39;s not a college savings fund, but a policy purchased for your child when they&#39;re still a baby will accumulate cash value over time (and grow tax&#45;deferred) that you could use to help pay for education expenses.
              </>
            }
            linkId='product-callout-whole-life-insurance-college-savings-plans-link'
            linkText='Find out more'
            linkUrl='/life-insurance/whole-life-insurance/'
          />
        </ColStyledProductCard>
      </Row>
    </SectionContainer>
  );
};
